import React from 'react';
import { CheckIcon } from 'lucide-react';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return;
}